import React from "react";
import logo from "../assets/images/logo.png";
import ovel from "../assets/images/bg-03.png";
import loginBg from "../assets/images/login-bg.png";
import { FaEye } from "react-icons/fa";

function Login() {
  return (
    <div className="login-bg">
      <>
        <div className="auth-wrapper">
          <div className="row">
            {/* <div className="col-lg-5">
              <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
                <div className="bg-overlay-img">
                  <img src={ovel} className="bg-1" alt="Img" />
                </div>
                <div className="authentication-card w-100">
                  <div className="authen-overlay-item border w-100">
                    <h1 className="text-white fs-40 fw-bold">
                      Empowering businesses through smart lead management.
                    </h1>
                    <div className="my-4 mx-auto authen-overlay-img">
                      <img src={loginBg} alt="Img" />
                    </div>
                    <div>
                      <p className="text-white fs-20 fw-semibold text-center">
                        Efficiently manage your workforce, streamline <br />{" "}
                        operations effortlessly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg-7 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
                <div className="col-md-7 mx-auto vh-100">
                  <form action="/">
                    {/* Authbox starts */}
                    <div className="auth-box">
                      {/* Logo starts */}
                      <a href="/" className="auth-logo mb-4">
                        <img src={logo} alt="Brand Logo" />
                      </a>
                      <div className="text-center mb-4">
                        <h3>Forgot Password</h3>
                        <p>
                          In order to access your dashboard, please enter the
                          email ID you provided during the registration process.
                        </p>
                      </div>
                      <div className="mb-4">
                        <label className="form-label" htmlFor="username">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="username"
                          className="form-control"
                          placeholder="Enter username"
                        />
                      </div>

                      <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Login;
